import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import changelogsGeneralPerformance from './charts/changelogsGeneralPerformance';

class PerformanceView {
    constructor(params) {
        this.isVisible = params.isVisible;
        this.isVisible.subscribe(val => {
            this.reinitIfVisible();
        });

        this.generalChartState = ko.observable('loading');
        this.generalChartOptions = ko.observable({});

        this.reinitIfVisible();
    }

    reinitIfVisible() {
        if (ko.unwrap(this.isVisible)) {
            this.loadGeneralChart();
        }
    }

    loadGeneralChart() {
        $api.insights.getChangelogsGeneralPerformance(
            {
                projectCode: auth.project.UniqueCode
            },
            {},
            (resp) => {
                const d = document.createElement('div');
                function unhtml(html) {
                    d.innerHTML = html;
                    return d.textContent;
                }

                var sum = [];
                var unique = [];

                for (var item of resp) {
                    sum.push(item.readCount);
                    unique.push(item.uniqueReadCount);
                }
                console.log(resp, sum, unique);
                if (sum.every(i => i === 0) && unique.every(i => i === 0)) {
                    this.generalChartState('empty');
                } else {
                    this.generalChartState('loaded');
                }

                var xAxisCategories = resp.map(i => unhtml(i.changelogTitle) || '');

                if (xAxisCategories.length === 0) return;

                this.generalChartOptions(changelogsGeneralPerformance(xAxisCategories, sum, unique));
            }
        );
    }

    //loadConversionChart() {
    //    $api.insights.getTourCardsPerformance(
    //        {
    //            projectCode: auth.project.UniqueCode,
    //            id: this.tourId
    //        },
    //        {},
    //        (resp) => {
    //            var xAxisCategories = resp.viewsByCards.map((i, index) => i.name || 'Step #' + (index + 1));

    //            this.conversionsChartOptions(constructTourCardsPerformance(xAxisCategories, resp.viewsByCards.map(i => i.views)));
    //        }
    //    );
    //}
}

export default koComponent('changelogs-performance-view', PerformanceView);